import React from 'react';
import { match } from 'ts-pattern';
import { KpiUiSingleColumn } from './KpiUiSingleColumnType1';
import { KpiUiTwoColumn } from './KpiUiTwoColumn';
import { KpiUiLayout, KpiUiOptions } from './types';

interface KpiUiProps {
  options: KpiUiOptions;
}

// Single unified KpiUi component that handles both layouts
export const KpiUi = (props: KpiUiProps) => {
  const { options } = props;
  return match(options)
    .with({ layout: KpiUiLayout.SINGLE_COLUMN }, (options) => {
      return <KpiUiSingleColumn options={options} />;
    })
    .with({ layout: KpiUiLayout.TWO_COLUMN }, (options) => {
      return <KpiUiTwoColumn options={options} />;
    })
    .exhaustive();
};
